import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles spi_improvements_roadmap tool - opens AI Roadmap dashboard in a new tab
 */
export const handleSpiImprovementsRoadmap = (options: HandlerOptions): void => {
  try {
    const { baseUrl } = options;
    const url = `${baseUrl}/dashboard/ai-roadmap`;

    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'spi_improvements_roadmap', url });
      logger.log('Opened AI Roadmap in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling SPI improvements roadmap:', error);
  }
};
